import Vue from 'vue'
import { URL_LOTS_COLLECTIONS, URL_LOTS } from '@/constants/urls.js'
import { LOTS, ERRORS, AXIOS_REQUESTS } from '@/constants/store.js'

const state = {
  [LOTS.STATE.LIST]: {
    draft: null,
    registered: null,
    finished: null,
    recalled: null
  },
  [LOTS.STATE.ACTIONS]: null
}
const getters = {
  [LOTS.GETTERS.ACTIONS_BY_LOT_ID]: (state) => (lotId) => {
    const actionsObj = (state.actions || []).find(a => a.lotId === lotId)
    return actionsObj || {}
  }
}
const actions = {
  async [LOTS.ACTIONS.GET_LOTS_LIST] ({ dispatch, commit }, model) {
    const lotStatus = model.lotStatus
    model = {
      url: `${Vue.getBusinessHost()}${URL_LOTS_COLLECTIONS}/${model.privacyType}/${model.lotStatus}?${Vue.helpers.getQueryParamsString(model.params)}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(LOTS.MUTATIONS.GET_LOTS_LIST, {
      lots: resp.data,
      lotStatus
    })
  },
  async [LOTS.ACTIONS.GET_LOT_ACTIONS] ({ dispatch, commit }, model) {
    const lotId = model.lotId

    model = {
      url: `${Vue.getBusinessHost()}${URL_LOTS}/${model.lotType}/${model.lotId}/${model.privacyType}/actions?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(LOTS.MUTATIONS.GET_LOT_ACTIONS, {
      ...resp.data,
      lotId
    })
  },
  async [LOTS.ACTIONS.CLEAR_LOTS_LIST] ({ commit }, lotStatus) {
    commit(LOTS.MUTATIONS.CLEAR_LOTS_LIST, lotStatus)
  },
  async [LOTS.ACTIONS.CLEAR_LOT_ACTIONS] ({ commit }) {
    commit(LOTS.MUTATIONS.CLEAR_LOT_ACTIONS)
  }
}

const mutations = {
  [LOTS.MUTATIONS.GET_LOTS_LIST] (state, model) {
    state[LOTS.STATE.LIST][model.lotStatus] = model.lots
  },
  [LOTS.MUTATIONS.GET_LOT_ACTIONS] (state, actions) {
    let actionsList = state[LOTS.STATE.ACTIONS] || []
    actionsList = actionsList.filter(a => a.lotId !== actions.lotId)

    actionsList.push(actions)
    state[LOTS.STATE.ACTIONS] = actionsList
  },
  [LOTS.MUTATIONS.CLEAR_LOTS_LIST] (state, lotStatus) {
    state[LOTS.STATE.LIST][lotStatus] = null
  },
  [LOTS.MUTATIONS.CLEAR_LOT_ACTIONS] (state) {
    state[LOTS.STATE.ACTIONS] = null
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
